import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../redux/slices/authSlice";
import {
  LuEye,
  LuEyeOff,
  LuUser,
  LuLock,
  LuMail,
  LuPhone,
  LuFingerprint,
  LuImage,
} from "react-icons/lu";
import Navbar from "../../components/companyLandingComponents/Navbar/Navbar";
import "./auth.css";
import BottomFooter from "../../components/Footer/BottomFooter/BottomFooter";

const RegisterPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [eyeOpen, setEyeOpen] = useState(false);
  const [eyeOpenConfirm, setEyeOpenConfirm] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    mobile_number: "",
    voter_id: "",
    role: "user",
    company: "",
    profile_photo_path: null,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, profile_photo_path: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) data.append(key, formData[key]);
    });

    try {
      const resultAction = await dispatch(registerUser(data));
      if (registerUser.fulfilled.match(resultAction)) {
        toast.success("Registration successful! Please login.");
        navigate("/profile", { state: resultAction.payload.user });
      } else {
        throw new Error(resultAction.payload || "Registration failed!");
      }
    } catch (err) {
      toast.error(err.message || "Registration failed!");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <Navbar />

      {/* Main Content Area with Dynamic Background */}
      <div className="flex-grow-1 position-relative d-flex align-items-center py-5">
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              'url("/assets/images/iconicback.jpg") center/cover no-repeat',
            zIndex: 0,
          }}
        ></div>

        <div
          className="container position-relative my-auto"
          style={{ zIndex: 1 }}
        >
          <div className="row justify-content-center">
            <div className="col-xxl-9 col-lg-11">
              <div
                className="card border-0 shadow-lg overflow-hidden"
                style={{
                  borderRadius: "15px",
                  backdropFilter: "blur(10px)",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                }}
              >
                <div className="row g-0">
                  {/* Branding Sidebar (Desktop) */}
                  <div
                    className="col-lg-4 d-none d-lg-flex flex-column align-items-center justify-content-center text-white p-5"
                    style={{ backgroundColor: "#2e86de" }}
                  >
                    <img
                      src="/assets/images/logo.png"
                      alt="logo"
                      className="img-fluid mb-4"
                      style={{
                        maxWidth: "180px",
                      }}
                    />
                    <h3 className="fw-bold text-center welcome-text">
                      Join Our Community
                    </h3>
                    <p className="text-center opacity-75">
                      Secure, fast, and easy registration to get you started in
                      minutes.
                    </p>
                    <div className="mt-4 border-top pt-4 w-100 text-center">
                      <small className="d-block mb-2">
                        Already have an account?
                      </small>
                      <Link
                        to="/login"
                        className="btn btn-outline-light rounded-pill px-4"
                      >
                        Log In
                      </Link>
                    </div>
                  </div>

                  {/* Form Section */}
                  <div className="col-lg-8 p-4 p-md-5">
                    <div className="d-lg-none text-center mb-4">
                      <img
                        src="/assets/images/logo.png"
                        alt="logo"
                        style={{ width: "120px" }}
                      />
                    </div>

                    <h2 className="fw-bold text-dark mb-1">Create Account</h2>
                    <p className="text-muted mb-4">
                      Please fill in the details below
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="row g-4">
                        {/* Left Side: Personal */}
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Full Name
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuUser size={18} />
                              </span>
                              <input
                                className="form-control bg-light"
                                type="text"
                                name="name"
                                onChange={handleChange}
                                placeholder="Enter your full name"
                                required
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Email Address
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuMail size={18} />
                              </span>
                              <input
                                className="form-control bg-light"
                                type="email"
                                name="email"
                                onChange={handleChange}
                                placeholder="email address"
                                required
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Mobile Number
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuPhone size={18} />
                              </span>
                              <input
                                className="form-control bg-light"
                                type="text"
                                name="mobile_number"
                                onChange={handleChange}
                                placeholder="01XXXXXXXXX"
                                required
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              NID Number
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuFingerprint size={18} />
                              </span>
                              <input
                                className="form-control bg-light"
                                type="text"
                                name="voter_id"
                                onChange={handleChange}
                                placeholder="13-digit NID"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        {/* Right Side: Security */}
                        <div className="col-md-6 border-start-md">
                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Profile Photo
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuImage size={18} />
                              </span>
                              <input
                                className="form-control bg-light"
                                type="file"
                                name="profile_photo_path"
                                onChange={handleFileChange}
                                accept="image/*"
                              />
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Password
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuLock size={18} />
                              </span>
                              <input
                                type={eyeOpen ? "text" : "password"}
                                name="password"
                                onChange={handleChange}
                                className="form-control bg-light"
                                placeholder="Password (min 8 characters)"
                                minLength={8}
                                required
                              />
                              <span
                                className="input-group-text bg-light border-start-0"
                                onClick={() => setEyeOpen(!eyeOpen)}
                                style={{ cursor: "pointer" }}
                              >
                                {eyeOpen ? (
                                  <LuEyeOff size={18} />
                                ) : (
                                  <LuEye size={18} />
                                )}
                              </span>
                            </div>
                          </div>

                          <div className="mb-3">
                            <label className="form-label small fw-semibold">
                              Confirm Password
                            </label>
                            <div className="input-group custom-input-group">
                              <span className="input-group-text bg-light text-muted">
                                <LuLock size={18} />
                              </span>
                              <input
                                type={eyeOpenConfirm ? "text" : "password"}
                                name="password_confirmation"
                                onChange={handleChange}
                                className="form-control bg-light"
                                placeholder="Confirm Password"
                                required
                              />
                              <span
                                className="input-group-text bg-light border-start-0"
                                onClick={() =>
                                  setEyeOpenConfirm(!eyeOpenConfirm)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                {eyeOpenConfirm ? (
                                  <LuEyeOff size={18} />
                                ) : (
                                  <LuEye size={18} />
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 pt-2">
                        <button
                          className="btn-style w-100 py-2 fw-bold shadow-sm d-flex justify-content-center align-items-center"
                          type="submit"
                          disabled={loading}
                          style={{ borderRadius: "8px", fontSize: "1.1rem" }}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                          ) : null}
                          <span>Sign Up Now</span>
                        </button>
                      </div>

                      <div className="text-center mt-4 d-lg-none">
                        <p className="text-muted small">
                          Already have an account?{" "}
                          <Link to="/login" className="text-primary fw-bold">
                            Log In
                          </Link>
                        </p>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline styles */}
      <style>{`
        @media (min-width: 768px) {
          .border-start-md {
            border-left: 1px solid #eee !important;
            padding-left: 2rem !important;
          }
        }
        .form-control:focus {
          box-shadow: none;
          border-color: #2e86de;
        }
        .input-group-text {
          color: #6c757d;
        }
      `}</style>

      <BottomFooter />
    </div>
  );
};

export default RegisterPage;